import { CoreIcon } from '../core-icon';
import chevronDownCircleSVG from '../../assets/icons/chevron-down-circle.svg';
import type { IconProps } from '../core-icon';

export const ChevronDownCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronDownCircleSVG} {...props} />;
};
